import { createSelector } from 'reselect';

import { QLog, QTask } from '@qwealth/qdata';

import { Activity } from '../models/Activity';
import { RootState } from 'data/store';
import { isQTask } from 'data/helpers/taskHelper';

export const selectHouseholdActivities = (state: RootState): Array<Activity> => state.householdActivities.all ?? [];

export const selectHouseholdTasks = createSelector(selectHouseholdActivities, (activities: Array<Activity>): Array<QTask> => {
  return activities.filter(isQTask);
});

export const selectHouseholdTaskById = createSelector(
  selectHouseholdTasks,
  (_: RootState, taskIdToFind: number | undefined) => taskIdToFind,
  (allTasks, taskIdToFind) => (taskIdToFind === undefined ? undefined : allTasks.find(task => task.id === taskIdToFind)),
);

export const selectHouseholdTasksByRecurringTaskId = createSelector(
  selectHouseholdTasks,
  (_: RootState, recurringTaskIdToFind: number | undefined | null) => recurringTaskIdToFind,
  (allTasks, recurringTaskIdToFind) => {
    if (recurringTaskIdToFind === undefined || recurringTaskIdToFind === null) return [];

    const filteredTasks = allTasks.filter(task => task.recurringTaskId === recurringTaskIdToFind);

    return filteredTasks.sort((a, b) => {
      const dateA = new Date(a.dueDate ? a.dueDate : '');
      const dateB = new Date(b.dueDate ? b.dueDate : '');
      return dateA.getTime() - dateB.getTime();
    });
  },
);

export const selectQBoardTasks = (state: RootState): Array<QTask> => state.activities.tasks ?? [];

export const selectQBoardTasksByRecurringTaskId = createSelector(
  selectQBoardTasks,
  (_: RootState, recurringTaskIdToFind: number | undefined) => recurringTaskIdToFind,
  (allTasks, recurringTaskIdToFind) => {
    if (recurringTaskIdToFind === undefined || recurringTaskIdToFind === null) return [];

    const filteredTasks = allTasks.filter(task => task.recurringTaskId === recurringTaskIdToFind);

    return filteredTasks.sort((a, b) => {
      const dateA = new Date(a.dueDate ? a.dueDate : '');
      const dateB = new Date(b.dueDate ? b.dueDate : '');
      return dateA.getTime() - dateB.getTime();
    });
  },
);

export const selectQBoardCallLogs = (state: RootState): Array<QLog> => state.activities.callLogs;

export const selectActivitiesQBoardIsLoading = (state: RootState): boolean => state.activities.isLoading;
